import { c as _c } from "react/compiler-runtime";
/* eslint-disable @next/next/no-img-element */
import Link from "next/link";
import { useRouter } from "next/navigation";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import { StarIcon } from "@heroicons/react/24/solid";
import FacebookIllustration from "public/assets/heroIllustrations/facebookIllustration.svg";
import AmazonIllustration from "public/assets/heroIllustrations/amazonIllustration.svg";
import AirBnbIllustration from "public/assets/heroIllustrations/airbnbIllustration.svg";
import GoogleIllustration from "public/assets/heroIllustrations/googleIllustration.svg";
import NewCircles from "public/assets/heroIllustrations/newCircles.svg";
import FreeText from "public/assets/heroIllustrations/freeText.svg";
import { cx } from "lib/cx";
import Image from "next/image";
import usersImage from "public/assets/heroIllustrations/usersImage.webp";
import atsImage from "public/assets/heroIllustrations/atsImage.webp";
import testimonialImage from "public/assets/heroIllustrations/testimonialImage.webp";
import GetResumeScoreIcon from "public/icons/getResumeScore.svg";
export const HeroMobile = () => {
  const $ = _c(23);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      router.push("/upload-resume");
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleCheckScore = t0;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-reveal line-1"><span className="text-[#52A1FF]">Enhance</span> Your Existing Resume</span>;
    t2 = <br />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-reveal line-2">Or <span className="text-[#52A1FF]">Generate</span> New Resume</span>;
    t4 = <br />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="mx-auto w-fit pt-5 text-center text-[18px] font-medium leading-5 tracking-tight md:text-[21px] md:leading-7">{t1}{t2}{t3}{t4}<span className="text-reveal line-3 flex items-center">For{" "}<FreeText className="inline-block h-[27px] w-[38px] lg:h-[36px] lg:w-[51px] xl:h-[45px] xl:w-[64px] 2xl:h-[53px] 2xl:w-[76px]" /></span></h1>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <img src="/assets/heroIllustrations/heroBgPattern.svg" alt="" className="absolute" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute left-1/2 top-[100px] -translate-x-1/2"><NewCircles className="rotating-circle mx-auto h-auto w-[260px] md:w-[500px]" /></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute left-1/2 top-28 -translate-x-1/2 "><img src="/assets/heroIllustrations/MobileResumeIllustration.svg" alt="" className={cx("fade-in-top-hero", "mx-auto h-[240px] w-[180px] md:h-[460px] md:w-[350px]")} /></div>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute left-3 top-36 md:left-40 md:top-40"><div className={cx("fade-in-diagonal-left", "h-[60px] w-[210px] md:h-[107px] md:w-[320px]")}><Image src={usersImage} alt="heroImg" fill={true} loading="eager" sizes="(min-width:768px) 40vw, 60vw" quality={85} /></div></div>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="absolute right-14 top-52 md:right-32 md:top-64"><div className={cx("fade-in-diagonal-right", "h-[120px] w-[100px] md:h-[254px] md:w-[200px]")}><Image src={atsImage} alt="heroImg" fill={true} loading="lazy" sizes="(min-width:768px) 30vw, 40vw" quality={85} /></div></div>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="min-h-[230px] md:min-h-[450px]">{t6}{t7}{t8}{t9}{t10}<div className="absolute left-0 top-40 md:left-16 md:top-56"><div className={cx("fade-in-diagonal-left", "h-[200px] w-[230px] md:h-[270px] md:w-[340px]")}><Image src={testimonialImage} alt="heroImg" fill={true} loading="lazy" sizes="(min-width:768px) 50vw, 70vw" quality={85} /></div></div></div>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FacebookIllustration className={cx("fade-in-left-hero del-1", "h-auto w-[40px] md:w-[57px]")} />;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <AmazonIllustration className={cx("fade-in-left-hero del-2 -ml-5", "h-auto w-[40px] md:w-[57px]")} />;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <AirBnbIllustration className={cx("fade-in-left-hero del-3 -ml-3", "h-auto w-[40px] md:w-[57px]")} />;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <GoogleIllustration className={cx("fade-in-left-hero del-4 -ml-4", "h-auto w-[40px] md:w-[57px]")} />;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="mx-auto mt-10 flex w-fit items-center">{t12}{t13}{t14}{t15}<img src="/assets/heroIllustrations/mobileNetflixIllustration.svg" alt="" className={cx("fade-in-left-hero del-5 -ml-4", "h-auto w-[40px] md:w-[57px]")} /></div>;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="fade-in-navbar mx-auto mt-5 w-fit text-[#3C3C3C]"><div className="mx-auto flex items-center gap-1"><StarIcon className="h-4 w-4 text-[#FFC700]" /><StarIcon className="h-4 w-4 text-[#FFC700]" /><StarIcon className="h-4 w-4 text-[#FFC700]" /><StarIcon className="h-4 w-4 text-[#FFC700]" /><StarIcon className="h-4 w-4 text-gray-300" /><div className="text-[12px] font-medium md:text-xs">4.5</div></div><div className="text-center text-[10px] md:text-xs">Rated by FAANG employees</div></div>;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Link href="/resume-builder"><button className="btn-gradient rounded-[40px] px-2 py-2 font-poppins min-[321px]:px-5 md:px-8">Generate Now <ArrowLongRightIcon className="h-auto w-4 md:w-6" /></button></Link>;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <GetResumeScoreIcon className="h-6 w-6" />;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  if ($[21] !== handleCheckScore) {
    t20 = <section className="relative bg-[#F9F9F9] px-8 font-montserrat lg:hidden">{t5}{t11}<div>{t16}{t17}<div className="fade-in-navbar mx-auto mt-5 flex w-full justify-center gap-2 text-[10px] md:gap-7 md:text-xs">{t18}<button className="flex items-center gap-2 rounded-[40px] px-2 py-2 font-poppins shadow-lg min-[321px]:px-5 md:px-8" onClick={handleCheckScore}>Get Resume Score {t19}</button></div></div></section>;
    $[21] = handleCheckScore;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  return t20;
};